<template>
  <div class="nominations">
    <div class="float-right" v-if="type==='hrbp' && nominations.length > 0">
      <div class="float-left pr-3">
        <router-link to="/my-profile/hrbp/dashboard">
          <i class="fas fa-clipboard-list fa-fw"></i>Graphical Dashboard
        </router-link>
      </div>
      <div class="float-left">
        Download current view as:
        <button type="button" class="btn btn-link p-0" v-on:click="exportToCSV()">
          <i class="fas fa-file-excel fa-2x" v-b-tooltip.hover title="Download as a CSV file"></i>
        </button>
        <button type="button" class="btn btn-link p-0" v-on:click="exportToPayrollCSV()" v-if="type === 'hrbp'">
          <i class="fas fa-check-square fa-2x" v-b-tooltip.hover title="Download Payroll CSV file"></i>
        </button>
      </div>
    </div>
    <b-collapse visible id="filterControls" accordion="link-accordion" role="tabpanel" style="clear:both;" v-if="type === 'hrbp'">
      <hr>
      <div class="row">
        <div class="col-sm-3 mb-2">
          <label>Nomination Category</label>
          <select v-model="nominationCategorySelect" v-on:change="loadNominations()" class="form-control">
            <option>-- All --</option>
            <option v-for="category in nominationCategories" v-bind:key="category.id" :value="category.id">{{category.name}}</option>
          </select>
        </div>
        <div class="col-sm-3 mb-2">
          <label for="nominatorFilter">From Date:</label>
          <div class="input-group">
            <input type="date" ref="fromDate" name="fromDate" id="fromDate" v-on:change="loadNominations()" />
          </div>
        </div>
        <div class="col-sm-3 mb-2">
          <label for="nomineeFilter">To Date:</label>
          <input type="date" ref="toDate" name="toDate" id="toDate" v-on:change="loadNominations()" />
        </div>
        <div class="col-sm-3 mb-2">
          <label>Payroll Month</label>
          <select v-model="payrollRange" :class="validationCLass">
            <option>-- Select --</option>
            <option v-for="pDate in payrollDates" v-bind:key="pDate.id" :value="pDate.id">{{pDate.value}}</option>
          </select>
        </div>
      </div>
    </b-collapse>
    <table class="table">
      <thead>
        <tr>
          <th class="text-black-50 border-top-0" scope="col">{{nomineeNominator}}</th>
          <th class="text-black-50 border-top-0" scope="col">Category</th>
          <th class="text-black-50 border-top-0" scope="col">Status</th>
          <th class="text-black-50 border-top-0" scope="col" v-if="type === 'review'">Downgrade</th>
        </tr>
      </thead>
      <tbody>
        <Nomination v-for="nomination in sortNominations" v-bind:key="nomination.id"
          :id="nomination.id"
          :name="getNomineeNominatorName(type, nomination)"
          :categories="getNominationCategories(nomination._embedded['wp:term'], nomination)"
          :status="getNominationStatus(nomination.teamnominationworkflow[0], nomination.id)"
          :downgradeStatus="getDowngradeNominationURL(nomination.id)"
          :profile-pic="(nomination.nominationteam[0] === null ? nomination._embedded.author[0].avatar_urls['48'] : 'https://thinktankapi-uat.multichoice.com/wp-content/uploads/2018/10/team-profile.png')"
          :type="type"
          :downgrade="downgrade">
        </Nomination>
      </tbody>
    </table>
  </div>
</template>

<script>
import Nomination from '@/components/Nomination'
import WordpressRestURI from '@/helpers/WordpressRestURI.js'
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
import ExportToCSV from '@/helpers/ExportToCSV.js'

export default {
  props: [
    'nominations',
    'type',
    'userDetails',
    'userEmail',
    'exportNomination'
  ],
  components: {
    Nomination
  },
  data() {
    return {
      nomineeSlug: [],
      nominationCategories: [],
      nominationCategorySelect: '-- All --',
      toDate: '',
      fromDate: '',
      orgNominations: [],
      csvNominations: [],
      slugChunks: [],
      payrollDates: [],
      payrollRange: '-- Select --',
      validationCLass: 'form-control',
      downgrade: null
    }
  },
  computed: {
    nomineeNominator: function () {
      console.log(this.userDetails, 'UD')
      console.log(this.type, 'type')
      if (this.type === 'sent' || this.type === 'hrbp') {
        return 'Nominee'
      } else if (this.type === 'review' || this.type === 'EmployeeAward') {
        return 'Nominee(s)'
      } else {
        return 'Nominator'
      }
    },
    sortNominations: function () {
      var self = this
      if (self.userDetails !== undefined) {
        // Code to execute if self.userDetails is not undefined
        console.log('ReviewNominations.vue if self.nominations self.userDetails ', self.userDetails)
      } else {
        console.log('ReviewNominations.vue else self.nominations self.userDetails ', self.userDetails)      
      }
      if (self.userEmail !== undefined) {
        // Code to execute if self.userDetails is not undefined
        console.log('ReviewNominations.vue if self.nominations self.userEmails ', self.userEmail)
      } else {
        console.log('ReviewNominations.vue else self.nominations self.userEmails ', self.userEmail)
      }
      console.log('ReviewNominations.vue self.nominations ', self.nominations, self.userDetails, self.userEmail)
      if (self.userDetails !== undefined && self.userEmail !== undefined) {
        return self.nominations.sort((t1, t2) => {
            var tempT1 = t1.teamnominationworkflow[0].filter(d => (d.project_sponsor_email.toLowerCase().trim() === self.userDetails.toLowerCase().trim() || d.project_sponsor_email.toLowerCase().trim() === self.userEmail.toLowerCase().trim()))
            var tempT2 = t2.teamnominationworkflow[0].filter(d => (d.project_sponsor_email.toLowerCase().trim() === self.userDetails.toLowerCase().trim() || d.project_sponsor_email.toLowerCase().trim() === self.userEmail.toLowerCase().trim()))
            console.log(' tempT1, tempT2 ', tempT1, tempT2, t1.teamnominationworkflow[0], t2.teamnominationworkflow[0])
            return tempT1[0].project_sponsor_status.localeCompare(tempT2[0].project_sponsor_status)
        })
      } else if (self.userDetails !== undefined) {
          return self.nominations.sort((t1, t2) => {
            var tempT1 = t1.teamnominationworkflow[0].filter(d => (d.project_sponsor_email.toLowerCase().trim() === self.userDetails.toLowerCase().trim()))
            var tempT2 = t2.teamnominationworkflow[0].filter(d => (d.project_sponsor_email.toLowerCase().trim() === self.userDetails.toLowerCase().trim()))
            return tempT1[0].project_sponsor_status.localeCompare(tempT2[0].project_sponsor_status)
        })   
      } else if (self.userEmail !== undefined && self.userDetails === undefined) {
        return self.nominations.sort((t1, t2) => {
            var tempT1 = t1.teamnominationworkflow[0].filter(d => (d.project_sponsor_email.toLowerCase().trim() === self.userEmail.toLowerCase().trim()))
            var tempT2 = t2.teamnominationworkflow[0].filter(d => (d.project_sponsor_email.toLowerCase().trim() === self.userEmail.toLowerCase().trim()))
            return tempT1[0].project_sponsor_status.localeCompare(tempT2[0].project_sponsor_status)
        })   
      }
    }
  },
  created() {
    var self = this
    self.orgNominations = this.nominations
    WordpressRestAPI.getViewContent('nomination_event_category?per_page=100&parent=20')
      .then(response => {
        self.nominationCategories = response.data.filter(x => x.id !== 22 && x.id !== 35 && x.id !== 21)
      })
      .catch(e => {
        console.error(e)
      })
    this.getMonths()
  },
  methods: {
    getDowngradeNominationURL: function (id) {
      return "/my-profile/downgrade-manager/"+id
    },
    generatedHRBPNominations: function () {
      console.log('i m called', this.exportNomination);
      var self = this
      self.csvNominations = []
      let check = self.exportNomination.map(function(x) {
        let temp = x.teamnominationworkflow[0].filter(d => d.project_sponsor_email.toLowerCase() === self.userDetails.toLowerCase() && d.project_sponsor_name === 'HRBP')
        if (temp.length > 0)
          self.csvNominations.push(x)
      })
      console.log('csvNoms->', self.csvNominations)
    },
    getMonths: function() {
      var today = new Date()
      var aMonth = today.getMonth()
      if (today.getDate() >= 20)
        aMonth++
      var months = []
      var aYear = today.getFullYear()
      var month = new Array("Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec")
      for (var i = 0; i < 12; i++) {
        let t = '20 ' + month[(aMonth - 2) < 0 ? (aMonth + 12) - 2 : aMonth - 2] + ' ' + ((aMonth - 2) < 0 ? aYear - 1 : aYear) + ' 00:00:00 - 19 ' + month[(aMonth - 1) < 0 ? (aMonth + 12) - 1 : aMonth - 1] + ' ' + ((aMonth - 1) < 0 ? aYear - 1 : aYear) + ' 23:59:59'
        months.push({id : t, value : month[aMonth] + ' ' + aYear})
        aMonth--
        if (aMonth < 0) {
          aMonth = 11
          aYear--
        }
      }
      this.payrollDates = months
    },
    gettypeDetail: function (type) {
      if (type === 'hrbp') {
        return 'hrbp'
      } else {
        return 'review'
      }
    },
    getNomineeNominatorName: function (type, nomination) {
      if (type === 'sent' || this.type === 'hrbp') {
        if (nomination.nominationteam[0] !== null) {
          return {name: nomination.nominationteam[0][0].member_name + ' and Team', slug: '#'}
        } else {
          return {name: nomination.nominee_name[0], slug: nomination.nominee_slug[0]}
        }        
      } else if ((type === 'review' || type === 'EmployeeAward') && nomination.nominationteam[0] !== null) {
        if (Array.isArray(nomination.nomination_event_category) && nomination.nomination_event_category.includes(141)) {
          console.log('Category contains 141 Regional EOM ', type)
          return {name: nomination.nominee_name[0], slug: nomination.nominee_slug[0]}
        } else if (nomination.nominationteam[0] !== null) {
          var teamNames = nomination.nominationteam[0][0].member_name + ' and Team'
          return {name: teamNames, slug: '#'}
        } else {
          return {name: nomination.nominee_name[0], slug: nomination.nominee_slug[0]}
        }
      } else if (type === 'review' || type === 'EmployeeAward') {
        return {name: nomination.nominee_name[0], slug: nomination.nominee_slug[0]}
      } else {
        return {name: nomination._embedded.author[0].name, slug: nomination._embedded.author[0].slug}
      }
    },
    getNominationStatus: function (teamnominationworkflow, id) {
      //let workflowStages = WordpressRestURI.workflowStages
      //let workflowStagesLabel = WordpressRestURI.workflowStagesLabel
      let workflowStages = ['sponsor', 'manager', 'exco2', 'hrbp']
      let workflowStagesLabel = ['Project Sponsor', 'Line Manager', 'Exco2', 'HCBP']
      let temp = []
      var data = []
      if (this.type === 'hrbp') {
        temp = teamnominationworkflow.filter(d => d.project_sponsor_email.toLowerCase() === this.userDetails.toLowerCase() && d.project_sponsor_name === 'HRBP')
        if (temp.length === 0) {
          temp = teamnominationworkflow.filter(d => d.project_sponsor_email.toLowerCase() === this.userEmail.toLowerCase() && d.project_sponsor_name === 'HRBP')
        }
      } else {
        temp = teamnominationworkflow.filter(d => d.project_sponsor_email.toLowerCase() === this.userDetails.toLowerCase() && d.project_sponsor_status === '')
        if (temp.length === 0) {
          temp = teamnominationworkflow.filter(d => d.project_sponsor_email.toLowerCase() === this.userEmail.toLowerCase() && d.project_sponsor_status === '')
        }
      }
      var queryString = ''
      var nextStageTemp = -1
      if (this.type === 'EmployeeAward' ) {
        nextStageTemp = 2
        data = [ 'my-profile/review-employee-award/' + id + '/' + workflowStages[nextStageTemp], 'Review as ' + workflowStagesLabel[nextStageTemp] ]
        return data        
      }
      else if (this.type === 'hrbp') {
        queryString = '?status=review'
        nextStageTemp = 3
        if (temp[0].project_sponsor_status === 'Reject') {
          data = [ 'my-profile/review-manager/' + id + '/' + workflowStages[nextStageTemp] + queryString, 'Rejection Review as ' + workflowStagesLabel[nextStageTemp] ]
        } else {
          data = [ 'my-profile/review-manager/' + id + '/' + workflowStages[nextStageTemp], temp[0].project_sponsor_status === 'Approve' ? 'Approved' : (temp[0].project_sponsor_status === 'Reject' ? 'Rejected' : temp[0].project_sponsor_status) ]
        }
        return data
      } else if (temp.length > 0) {
        for (var t = 0; t < temp.length; t++) {
          var tempnextStage = workflowStages.indexOf(temp[t].project_sponsor_name.toLowerCase())
          if (nextStageTemp > tempnextStage || nextStageTemp === -1) {
            nextStageTemp = tempnextStage
          }
        }
        if (temp[0].project_sponsor_status === '') {
          data = [ 'my-profile/review-manager/' + id + '/' + workflowStages[nextStageTemp] + queryString, 'Review as ' + workflowStagesLabel[nextStageTemp] ]
        } else {
          data = [ '#', temp[0].project_sponsor_status === 'Approve' ? 'Approved' : (temp[0].project_sponsor_status === 'Reject' ? 'Rejected' : temp[0].project_sponsor_status) ]
        }
        return data
      }
    },
    getNominationCategories: function (categoryTerms, nomination) {
      let nomCat = []
      for (var i = 0; i < categoryTerms.length; i++) {
        if (categoryTerms[i].length > 0) {
          if (categoryTerms[i][0].taxonomy === 'nomination_event_category') {
            for (var j = 0; j < categoryTerms[i].length; j++) {
              nomCat.push({id: categoryTerms[i][j].id, name: categoryTerms[i][j].name})
            }
          }
        }
      }
      return nomCat
    },
    exportContentData: function (data) {
      var chunks = data[0].split(' @#$% ')
      var header = ''
      var value = ''
      var exportData = []
      chunks.map(function (val, index) {
        if (val.indexOf('<h>') > -1) {
          header = val.replace(/<h>/g, '').replace(/<strong>/g, '').replace(/<\/strong>/g, '').replace(/<p>/g, '').replace(/<\/p>/g, '').replace(/<ul>/g, '').replace(/<\/ul>/g, '').replace(/<li>/g, '').replace(/<\/li>/g, '').replace(/<br>/g, ' ').replace(/<br\/>/g, ' ').replace(/,/g, ';')
          // console.log('val of <h> ' + index, header)
        }
        if (val.indexOf('<c>') > -1) {
          value = val.replace(/<c>/g, '').replace(/<strong>/g, '').replace(/<\/strong>/g, '').replace(/<p>/g, '').replace(/<\/p>/g, '').replace(/<ul>/g, '').replace(/<\/ul>/g, '').replace(/<li>/g, '').replace(/<\/li>/g, '').replace(/<br>/g, ' ').replace(/<br\/>/g, ' ').replace(/,/g, ';').replace(/’/g, '\'').replace(/“/g, '"').replace(/”/g, '"')
          // console.log('val of <c> ' + index, value)
          exportData[header] = value
        }
      })
      return exportData
    },
    getSingleNomineeInfo: function (x) {
      var nomineesInfo = { 'nomineeName': [], 'nomineeEmployeNumber': [], 'nomineeEmail': [], 'nomineeCompany': [], 'businessUnit': [], 'country': [], 'gom': [], 'projectSponsor': 'NA', 'projectSponsorApproved': 'NA', 'projectSponsorDeclinedReason': 'NA', 'projectSponsorDate': 'NA' }
      nomineesInfo.nomineeName = x.nominee_name[0]
      nomineesInfo.nomineeEmployeNumber = x.nominee_employeeNumber[0]
      nomineesInfo.nomineeEmail = x.nominee_slug[0].replace(/multichoice/g, '@multichoice').replace(/-/g, '.')
      nomineesInfo.nomineeCompany = (x.nominee_company.length) ? x.nominee_company[0].replace(/,/g, ' ') : ''
      nomineesInfo.businessUnit = ' '
      nomineesInfo.country = ' '
      nomineesInfo.gom = ' '
      if ('employeehierarchy' in x.nominee_slug && x.nominee_slug.employeehierarchy) {
        nomineesInfo.nomineeEmail = x.nominee_slug[1]
        nomineesInfo.businessUnit = 'businessunit' in x.nominee_slug.employeehierarchy ? x.nominee_slug.employeehierarchy.businessunit[0] : ''
        nomineesInfo.country = x.nominee_slug.employeehierarchy.country[0]
        nomineesInfo.gom = x.nominee_slug.employeehierarchy.gom[0]
        if ('employeenumber' in x.nominee_slug.employeehierarchy)
          nomineesInfo.nomineeEmployeNumber = x.nominee_slug.employeehierarchy.employeenumber[0]
      }
      return nomineesInfo
    },
    getNomineeInfo: function (nomineesInfo, x, i, count) {
      nomineesInfo.nomineeName += (count - 1 === i) ? x.member_name : x.member_name + ' $&$ '
      var nomineeEmployeNumber = (count - 1 === i) ? x.member_employee_number : x.member_employee_number + ' $&$ '
      nomineesInfo.nomineeCompany += (count - 1 === i) ? x.member_company.replace(/,/g, ' ') : x.member_company.replace(/,/g, ' ') + ' $&$ '
      var employeeNumberflag = true
      nomineesInfo.nomineeCompany += (count - 1 === i) ? x.member_company.replace(/,/g, ' ') : x.member_company.replace(/,/g, ' ') + ' $&$ '

      if (x.member_email.indexOf('@') > -1 && 'businessunit' in x.employeehierarchy) {
        nomineesInfo.nomineeEmail += (count - 1 === i) ? x.member_email : x.member_email + ' $&$ '
        nomineesInfo.businessUnit += (count - 1 === i) ? x.employeehierarchy.businessunit[0] : x.employeehierarchy.businessunit[0] + ' $&$ '
        nomineesInfo.country += (count - 1 === i) ? x.employeehierarchy.country[0] : x.employeehierarchy.country[0] + ' $&$ '
        nomineesInfo.gom += (count - 1 === i) ? x.employeehierarchy.gom[0] : x.employeehierarchy.gom[0] + ' $&$ '
        if ('employeenumber' in x.employeehierarchy) {
          employeeNumberflag = false
          nomineesInfo.nomineeEmployeNumber += (count - 1 === i) ? x.employeehierarchy.employeenumber[0] : x.employeehierarchy.employeenumber[0] + ' $&$ '
        }
      }
      else {
        nomineesInfo.gom = nomineesInfo.nomineeCompany
        nomineesInfo.businessUnit += (count - 1 === i) ? ' '  : '  $&$ '
        nomineesInfo.country += (count - 1 === i) ? ' '  : '  $&$ '
        var emailCreator = ''
        var emailCreatorName = ''
        emailCreator = x.member_name.replace(/ /g, '.') + '@'
        emailCreatorName = x.member_name.toLowerCase().replace(/ /g, '-')
        emailCreator = x.member_slug.replace(emailCreatorName, emailCreator).replace(/-/g, '.')
        if (x.member_company.toLowerCase().indexOf('multichoice') > -1) {
          nomineesInfo.nomineeEmail += (count - 1 === i) ? emailCreator : emailCreator + ' $&$ '
        } else {
          nomineesInfo.nomineeEmail += (count - 1 === i) ? x.member_slug.replace(/multichoice/g, '@multichoice').replace(/-/g, '.') : x.member_slug.replace(/multichoice/g, '@multichoice').replace(/-/g, '.') + ' $&$ '
        }
      }
      if (employeeNumberflag == true)
        nomineesInfo.nomineeEmployeNumber += nomineeEmployeNumber
      return nomineesInfo
    },
    exportTeamData: function (teamDetails) {
      var self = this
      var nomineesInfo = {'nomineeName': [], 'nomineeEmployeNumber': [], 'nomineeEmail': [], 'nomineeCompany': [], 'businessUnit': [], 'country': [], 'gom': []}
      var count = teamDetails.length
      if (count > 1) {
        teamDetails.map(function (x, i) {
          nomineesInfo = self.getNomineeInfo(nomineesInfo, x, i, count)
        })
      } else {
        teamDetails[0].map(function (x, i) {
          nomineesInfo = self.getNomineeInfo(nomineesInfo, x, i, count)
        })
      }
      return nomineesInfo
    },
    getDateTime: function (val, needle, index) {
      if(val !== undefined && val !== null && val !== "" && val !== "NA") {
        return val.split(needle)[index]
      } else {
        return 'NA'
      }
    },
    exportToCSV: function () {
      var self = this
      // Map fields of nominations array that will be converted to CSV
      // const items = this.nominations.map(function (x) {
      this.generatedHRBPNominations()
      const items = this.csvNominations.map(function (x) {
        var splitData = {}
        var nomineesDetails = {}
        do {
          if (x.teamnominationworkflow[0].length === 1) {
            console.log('moved ->  ')
            x.teamnominationworkflow[0] = x.teamnominationworkflow[0][0]
          }
        } while (x.teamnominationworkflow[0].length === 1)

        if (x.nominationdata.length) {
          splitData = self.exportContentData(x.nominationdata)
        }
        if (x.isteamaward[0] === 'true' || x.nominationteam[0]) {
          nomineesDetails = self.exportTeamData(x.nominationteam[0])
          if (x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Sponsor')).length > 0) {
            nomineesDetails.projectSponsor = (x.teamnominationworkflow.length) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Sponsor'))[0]['project_sponsor_email'] : ''
            nomineesDetails.projectSponsorApproved = (x.teamnominationworkflow.length) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Sponsor'))[0]['project_sponsor_status'] : ''
            nomineesDetails.projectSponsorDeclinedReason = (x.teamnominationworkflow.length) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Sponsor'))[0]['project_sponsor_comment'] : ''
            nomineesDetails.projectSponsorDate = (x.teamnominationworkflow.length) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Sponsor'))[0]['project_sponsor_datetime'] : ''
          }
        } else {
          nomineesDetails = self.getSingleNomineeInfo(x)
        }
        const temp = Object.assign({}, {
          Nominator_Name: x._embedded.author[0].name,
          Nominator_Employee_Number: x.nominator_details[0][0]['employee-number'],
          Nominee_Name: nomineesDetails.nomineeName,
          Nominee_Employee_Number: nomineesDetails.nomineeEmployeNumber,
          Nominee_Email: nomineesDetails.nomineeEmail,
          BU: nomineesDetails.businessUnit,
          GOM: nomineesDetails.gom,
          Country: nomineesDetails.country,
          Award_Category: (x._embedded['wp:term'][1].length) ? x._embedded['wp:term'][1][0].name : x.title.rendered,
          Nominee_Status: x.nomination_approve_decline[0],
          Date_Of_Nomination: x.date.split('T')[0],
          Time_Of_Nomination: x.date.split('T')[1],
          Project_Sponsor: nomineesDetails.projectSponsor,
          Project_Sponsor_Approved: nomineesDetails.projectSponsorApproved,
          Project_Sponsor_Reason: nomineesDetails.projectSponsorDeclinedReason,
          Project_Sponsor_Date: self.getDateTime(nomineesDetails.projectSponsorDate, ' ', 0),
          Project_Sponsor_Time: self.getDateTime(nomineesDetails.projectSponsorDate, ' ', 1),
          Line_Manager: (x.teamnominationworkflow.length) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Manager'))[0]['project_sponsor_email'] : 'NA',
          Line_Manager_Approved: (x.teamnominationworkflow.length) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Manager'))[0]['project_sponsor_status'] : 'NA',
          Line_Manager_Reason: (x.teamnominationworkflow.length) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Manager'))[0]['project_sponsor_comment'] : 'NA',
          Line_Manager_Date: (x.teamnominationworkflow.length) ? self.getDateTime(x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Manager'))[0]['project_sponsor_datetime'], ' ', 0) : 'NA',
          Line_Manager_Time: (x.teamnominationworkflow.length) ? self.getDateTime(x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Manager'))[0]['project_sponsor_datetime'], ' ', 1) : 'NA',
          Exco2: (x.teamnominationworkflow.length) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Exco2'))[0]['project_sponsor_email'] : 'NA',
          Exco2_Approved: (x.teamnominationworkflow.length) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Exco2'))[0]['project_sponsor_status'] : 'NA',
          Exco2_Reason: (x.teamnominationworkflow.length) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Exco2'))[0]['project_sponsor_comment'] : 'NA',
          Exco2_Date: (x.teamnominationworkflow.length) ? self.getDateTime(x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Exco2'))[0]['project_sponsor_datetime'], ' ', 0) : 'NA',
          Exco2_Time: (x.teamnominationworkflow.length) ? self.getDateTime(x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Exco2'))[0]['project_sponsor_datetime'], ' ', 1) : 'NA',
          HRBP: (x.teamnominationworkflow.length) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'HRBP'))[0]['project_sponsor_email'] : 'NA',
          HRBP_Approved: (x.teamnominationworkflow.length) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'HRBP'))[0]['project_sponsor_status'] : 'NA',
          HRBP_Reason: (x.teamnominationworkflow.length) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'HRBP'))[0]['project_sponsor_comment'] : 'NA',
          HRBP_Date: (x.teamnominationworkflow.length) ? self.getDateTime(x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'HRBP'))[0]['project_sponsor_datetime'], ' ', 0) : 'NA',
          HRBP_Time: (x.teamnominationworkflow.length) ? self.getDateTime(x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'HRBP'))[0]['project_sponsor_datetime'], ' ', 1) : 'NA'
        }, splitData)
        return temp
      })

      var keysOnly = []
      for (var k = 0; k < items.length; k++) {
        keysOnly = keysOnly.concat(Object.keys(items[k]))
      }

      let csvKeys = keysOnly.filter((v, i) => keysOnly.indexOf(v) === i)

      for (var i = 0; i < items.length; i++) {
        for (var j = 0; j < csvKeys.length; j++) {
          console.log(j, csvKeys[j])
          if (items[i][csvKeys[j]]) {
            items[i][csvKeys[j]] = items[i][csvKeys[j]]
          } else {
            items[i][csvKeys[j]] = ''
          }
        }
      }

      let cloneItems = []
      let dupItems = JSON.parse(JSON.stringify(items))
      var iIndex = 0
      for (var u=0; u<dupItems.length; u++) {
        if (dupItems[u].Nominee_Name.includes(' $&$ ')) {
          var nomineeNameCount = dupItems[u].Nominee_Name.split(' $&$ ')
          var nomineeEmployeNumberCount = dupItems[u].Nominee_Employee_Number.split(' $&$ ')
          var nomineeEmailCount = dupItems[u].Nominee_Email.split(' $&$ ')
          var nomineeCompanyCount = dupItems[u].GOM.split(' $&$ ')
          for (var w=0; w<nomineeNameCount.length; w++) {
            cloneItems[iIndex] = JSON.parse(JSON.stringify(dupItems[u]))
            cloneItems[iIndex].Nominee_Name = nomineeNameCount[w]
            cloneItems[iIndex].Nominee_Employee_Number = nomineeEmployeNumberCount[w]
            cloneItems[iIndex].Nominee_Email = nomineeEmailCount[w]
            cloneItems[iIndex].GOM = nomineeCompanyCount[w]
            iIndex++
          }
        } else {
          cloneItems[iIndex] = JSON.parse(JSON.stringify(dupItems[u]))
          iIndex++
        }
      }
      // ExportToCSV.createCSV(Object.values(cloneItems), 'VE_Awards_Nominations')
      ExportToCSV.createCSV(items, 'Recognition', 'Nominee_Name', ['Project_Sponsor', 'Project_Sponsor_Approved', 'Project_Sponsor_Reason', 'Project_Sponsor_Date','Line_Manager', 'Line_Manager_Approved', 'Line_Manager_Reason', 'Line_Manager_Date','Exco2', 'Exco2_Approved', 'Exco2_Reason', 'Exco2_Date','HRBP', 'HRBP_Approved', 'HRBP_Reason', 'HRBP_Date'])
    },
    getApprovedNomination: function () {
      return this.nominations.filter(function(d) {
        if (d.nomination_event_category[0] === 103 || d.nomination_event_category[0] === 104)
        return d.teamnominationworkflow[0].reduce(function(r, e) {
          if (e.project_sponsor_status === 'Approve' && r)
            return true
          else
            return false
        })
      })
    },
    getPerMonthOntheSpotNomination: function (approvedNomination) {
      var monthName = new Intl.DateTimeFormat("en-US", { month: "short" }).format
      var yearName = new Intl.DateTimeFormat("en-US", { year: "numeric"}).format
      var dateNomination = []
      let dateVal = ''
      let compareDateValFrom = '', compareDateValTo = ''
      var self = this
      let nominations = approvedNomination.map(function(x) {
        dateVal = monthName(new Date(x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'HRBP'))[0]['project_sponsor_datetime'])) + ' ' +  yearName(new Date(x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'HRBP'))[0]['project_sponsor_datetime']))
        compareDateValFrom = monthName(new Date(self.payrollRange.split(' - ')[0])) + ' ' +  yearName(new Date(self.payrollRange.split(' - ')[0]))
        compareDateValTo = monthName(new Date(self.payrollRange.split(' - ')[1])) + ' ' +  yearName(new Date(self.payrollRange.split(' - ')[1]))
        if (dateNomination.length > 1) {
          if (dateNomination.filter(m => m.date === dateVal && m.data.nomination_event_category[0] === 103).length === 0)
            dateNomination.push( {date: dateVal, data: x } )
          else if (dateNomination.filter(m => m.date === dateVal  && m.data.nomination_event_category[0] === 103 && dateNomination.filter(t => t.data.nominee_slug[1] !== m.data.nominee_slug[1])).length === 0)
            dateNomination.push( {date: dateVal, data: x } )
          else if (dateNomination.filter(m => m.date === dateVal  && m.data.nomination_event_category[0] === 103 && dateNomination.filter(t => t.data.nominee_slug[1] === m.data.nominee_slug[1])).length <= 1)
            dateNomination.push( {date: dateVal, data: x } )
        }
        else {
          dateNomination.push( {date: dateVal, data: x} )
        }
      })
      return dateNomination.map(function(x){ return x.data})
    },
    exportToPayrollCSV: function () {
      if (this.payrollRange === '-- Select --') {
        this.validationCLass = 'form-control is-invalid'
        alert('Please select Payroll Moth')
      }
      else {
        this.validationCLass = 'form-control'
        var self = this
        // Map fields of nominations array that will be converted to CSV
        var nonTeamHeader = {}
        // var approvedNomination = self.getPerMonthOntheSpotNomination(self.getApprovedNomination())
        var approvedNomination = self.getApprovedNomination()
        console.log('approvedNomination', approvedNomination)
        const items = approvedNomination.map(function (x) {
          if ( (Date.parse(self.payrollRange.split(' - ')[0]) < Date.parse(x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'HRBP'))[0]['project_sponsor_datetime']) ) && ( Date.parse(self.payrollRange.split(' - ')[1]) > Date.parse(x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'HRBP'))[0]['project_sponsor_datetime']) ) ) {
            var splitData = {}
            var nomineesDetails = {}
            do {
              if (x.teamnominationworkflow[0].length == 1) {
                // console.log('moved ->  ')
                x.teamnominationworkflow[0] = x.teamnominationworkflow[0][0]
              }
            } while(x.teamnominationworkflow[0].length == 1)

            if (x.nominationdata.length)
              splitData = self.exportContentData(x.nominationdata)
            if (x.isteamaward[0] === 'true' || x.nominationteam[0]) {
              nomineesDetails = self.exportTeamData(x.nominationteam[0])
              if (x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Sponsor')).length > 0) {
                nomineesDetails.projectSponsor = (x.teamnominationworkflow.length) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Sponsor'))[0]['project_sponsor_email'] : ''
                nomineesDetails.projectSponsorApproved = (x.teamnominationworkflow.length) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Sponsor'))[0]['project_sponsor_status'] : ''
                nomineesDetails.projectSponsorDeclinedReason = (x.teamnominationworkflow.length) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Sponsor'))[0]['project_sponsor_comment'] : ''
                nomineesDetails.projectSponsorDate = (x.teamnominationworkflow.length) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Sponsor'))[0]['project_sponsor_datetime'] : ''
              }
            }
            else {
              nomineesDetails = {nomineeName: x.nominee_name[0], nomineeEmployeNumber: x.nominee_employeeNumber[0], nomineeEmail: x.nominee_slug[0].replace(/multichoice/g, '@multichoice').replace(/-/g,'.'), nomineeCompany: (x.nominee_company.length) ? x.nominee_company[0].replace(/,/g, ' ') : '', projectSponsor: 'NA', projectSponsorApproved: 'NA', projectSponsorDeclinedReason: 'NA', projectSponsorDate: 'NA', businessUnit: x.nominee_slug.employeehierarchy.businessunit[0], country: x.nominee_slug.employeehierarchy.country[0], gom: x.nominee_slug.employeehierarchy.gom[0]}
            }

            let dateVal = x.date.split('T')
            var monthName = new Intl.DateTimeFormat("en-US", { month: "short" }).format
            var yearName = new Intl.DateTimeFormat("en-US", { year: "numeric"}).format
            const temp = {
              Nominee_Name: nomineesDetails.nomineeName,
              Nominee_Employee_Number: nomineesDetails.nomineeEmployeNumber,
              Nominee_Email: nomineesDetails.nomineeEmail,
              BU: nomineesDetails.businessUnit,
              GOM: nomineesDetails.gom,
              Award_Category: (x._embedded['wp:term'][1].length) ? x._embedded['wp:term'][1][0].name : x.title.rendered,
              Country: nomineesDetails.country,
              Date_Of_Nomination: x.date.split('T')[0],
              HRBP: (x.teamnominationworkflow.length) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'HRBP'))[0]['project_sponsor_email'] : 'NA',
              Payroll_Amount_NET: (nomineesDetails.country.toLowerCase().indexOf('south africa') === 0 || nomineesDetails.country.toLowerCase() === 'south africa') ? (x._embedded['wp:term'][1][0].id === 103) ? nomineesDetails.country.split('$&$').fill('1000 ZAR').join(' $&$ ') : nomineesDetails.country.split('$&$').fill('2000 ZAR').join(' $&$ ') : (x._embedded['wp:term'][1][0].id === 103) ? nomineesDetails.country.split('$&$').fill('75 USD').join(' $&$ ') : nomineesDetails.country.split('$&$').fill('150 USD').join(' $&$ '),
              Payroll_Month: self.payrollDates.filter(x => (x.id === self.payrollRange))[0].value
            }
            return temp
          }
        })
        let itemsCount = items.filter(function(t){ return t !== undefined })
        console.log('itemsCount'. itemsCount)
        if (itemsCount.length === 0) {
          this.validationCLass = 'form-control is-invalid'
          alert('No Records in Selected Payroll Month')
        }
        else {
          ExportToCSV.createCSV(itemsCount, 'Payroll', 'Nominee_Name')
        }
      }
    },
    loadNominations: function() {
      var self = this
      if (self.$refs.toDate)
        // if (self.$refs.toDate.value !== '')
          self.toDate = self.$refs.toDate.value

      if (self.$refs.fromDate)
        // if (self.$refs.fromDate.value !== '')
          self.fromDate = self.$refs.fromDate.value

      if (( self.toDate !== '' && self.fromDate !== '') || (self.nominationCategorySelect !== '-- All --')) {
        let newNominations = self.orgNominations.filter(function(v) {

          if ( self.toDate !== '' && self.fromDate !== '') {
            if ( (Date.parse(self.fromDate + ' 00:00:00') < Date.parse(v.date) ) && ( Date.parse(self.toDate + ' 23:59:59') > Date.parse(v.date) ) ) {
              if (self.nominationCategorySelect === '-- All --') {
                return v
              } else if (v._embedded['wp:term'][1][0].id === self.nominationCategorySelect || v._embedded['wp:term'][1][1].id ===  self.nominationCategorySelect) {
                return v
              }
            }
          }
          if (v._embedded['wp:term'][1][0].id === self.nominationCategorySelect || v._embedded['wp:term'][1][1].id ===  self.nominationCategorySelect) {
            if ( self.toDate === '' && self.fromDate === '') {
              return v
            } else if ( (Date.parse(self.fromDate + ' 00:00:00') < Date.parse(v.date) ) && ( Date.parse(self.toDate + ' 23:59:59') > Date.parse(v.date) ) ) {
              return v
            }
          }
        })
        self.nominations = newNominations
      }
      else {
        self.nominations = self.orgNominations
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ReviewNominations.vue